import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const ANIMATION_DURATION = 300;

export default class SlideOutPanel extends Component {
    closeTimer = null;
    animationTimer = null;
    _isMounted = true;

    state = {
        closing: false,
        pinned: false
    }

    componentWillUnmount() {
        this._isMounted = false;
        clearTimeout(this.closeTimer);
        clearTimeout(this.animationTimer);
    }

    handleHide = () => {
        if (this.state.closing || !this.props.show) {
            return;
        }
        clearTimeout(this.closeTimer);
        this.setState({closing: true});
        this.animationTimer = setTimeout(() => {
            if (this._isMounted) {
                this.props.onHide();
                this.setState({closing: false});
            }
        }, ANIMATION_DURATION);
    }

    togglePin = () => {
        this.setState(prev => {
            if (!prev.pinned) {
                clearTimeout(this.closeTimer);
            }
            return {pinned: !prev.pinned};
        });
    }

    onMouseLeave = () => {
        if (this.state.closing || this.state.pinned) {
            return;
        }
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => {
            if (this._isMounted) {
                this.handleHide();
            }
        }, 3000);
    }

    onMouseEnter = () => {
        clearTimeout(this.closeTimer);
    }

    render() {
        if (!this.props.show && !this.state.closing) {
            return null;
        }

        const closing = this.state.closing;

        return ReactDOM.createPortal(
            <div>
                <div className={`slide-out-panel-overlay${closing ? ' slide-out-panel-overlay--closing' : ''}`}
                     onClick={this.handleHide}/>
                <div className={`slide-out-panel${closing ? ' slide-out-panel--closing' : ''}`}
                     onClick={(e) => e.stopPropagation()}
                     onMouseLeave={this.onMouseLeave}
                     onMouseEnter={this.onMouseEnter}
                >
                    <div className="slide-out-panel__head">
                        <div>
                            <div className="slide-out-panel__title">{this.props.title}</div>
                            {this.props.subtitle && <div className="slide-out-panel__subtitle">{this.props.subtitle}</div>}
                        </div>
                        <div className="slide-out-panel__actions">
                            {this.props.onDownload && <div className="slide-out-panel__action-btn" onClick={this.props.onDownload}>
                                <i className="fas fa-download"/>
                            </div>}
                            <div className={`slide-out-panel__pin${this.state.pinned ? ' slide-out-panel__pin--active' : ''}`} onClick={this.togglePin}>
                                <i className="fas fa-thumbtack"/>
                            </div>
                            <div className="slide-out-panel__close" onClick={this.handleHide}>
                                <i className="fas fa-times"/>
                            </div>
                        </div>
                    </div>
                    <div className="slide-out-panel__body">
                        {this.props.children}
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

SlideOutPanel.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onDownload: PropTypes.func,
    children: PropTypes.any
}
